import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a06ad2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intended-customer-wrapper" }
const _hoisted_2 = { class: "info-table-wrapper" }
const _hoisted_3 = { class: "table-toolbar" }
const _hoisted_4 = { class: "table-option-buttons" }
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_search = _resolveComponent("filter-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_info_wrapper = _resolveComponent("info-wrapper")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_sms_detail_modal = _resolveComponent("sms-detail-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_info_wrapper, { title: "短信模板配置" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.tableInfo.isHas)
              ? (_openBlock(), _createBlock(_component_filter_search, {
                  key: 0,
                  rows: _ctx.tableInfo.rows,
                  rules: _ctx.tableInfo.rules,
                  onUpdateReqParams: _ctx.tableInfo.updateReqParams,
                  onSearch: _ctx.tableInfo.search,
                  onResearch: _ctx.tableInfo.research
                }, null, 8, ["rows", "rules", "onUpdateReqParams", "onSearch", "onResearch"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                type: "primary",
                style: {"margin-left":"15px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editInfo.showCreateModal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加 ")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_table, {
              bordered: "",
              "row-key": "id",
              "row-selection": { selectedRowKeys: _ctx.tableInfo.state.selectedRowKeys, onChange: _ctx.tableInfo.onSelectChange },
              columns: _ctx.tableInfo.columns,
              "data-source": _ctx.tableInfo.data,
              onChange: _ctx.tableInfo.handleChange,
              pagination: _ctx.tableInfo.paginationConfig,
              rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
              scroll: { x: '1300px' }
            }, {
              ope: _withCtx(({record}) => [
                _createElementVNode("span", {
                  class: "cursor",
                  onClick: ($event: any) => (_ctx.opeInfo.showDetailModal(record))
                }, "详情", 8, _hoisted_6),
                _createElementVNode("span", {
                  class: "cursor",
                  onClick: ($event: any) => (_ctx.editInfo.showEditModal(record))
                }, "编辑", 8, _hoisted_7),
                _createElementVNode("span", {
                  class: "cursor delete-cursor",
                  onClick: ($event: any) => (_ctx.opeInfo.showDeleteDialog(record))
                }, "删除", 8, _hoisted_8)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "data-source", "onChange", "pagination", "rowClassName"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.editInfo.modalConfig.visible,
      title: _ctx.editInfo.modalConfig.modalName,
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editInfo.cancel())),
      onOk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editInfo.confirm())),
      width: "600px",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.editInfo.formData,
          "label-col": {span:4},
          "wrapper-col": {span:16},
          labelAlign: "right",
          rules: _ctx.editInfo.rules,
          ref: _ctx.editInfo.setValidateForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "名称",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editInfo.formData.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editInfo.formData.name) = $event)),
                  placeholder: "请输入模板名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "编码",
              name: "code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editInfo.formData.code,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editInfo.formData.code) = $event)),
                  placeholder: "请输入模板编码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "签名",
              name: "signName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.editInfo.formData.signName,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editInfo.formData.signName) = $event)),
                  placeholder: "请输入模板签名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editInfo.formData.itemList, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_form_item, {
                label: `参数${index+1}`,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    placeholder: "请输入参数英文名",
                    value: item.key,
                    "onUpdate:value": ($event: any) => ((item.key) = $event),
                    style: {"width":"40%","margin-right":"8px"}
                  }, null, 8, ["value", "onUpdate:value"]),
                  _createVNode(_component_a_input, {
                    placeholder: "请输入参数中文名",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    style: {"width":"40%","margin-right":"8px"}
                  }, null, 8, ["value", "onUpdate:value"]),
                  (_ctx.editInfo.formData.itemList.length>1)
                    ? (_openBlock(), _createBlock(_component_MinusCircleOutlined, {
                        key: 0,
                        class: "dynamic-delete-button",
                        onClick: ($event: any) => (_ctx.editInfo.removeItem(item))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128)),
            _createVNode(_component_a_form_item, {
              label: " ",
              name: "",
              colon: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "dashed",
                  style: {"width":"60%"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editInfo.addItem()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PlusOutlined),
                    _createTextVNode(" 添加参数 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板内容",
              name: "template"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.editInfo.formData.template,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editInfo.formData.template) = $event)),
                  placeholder: "请输入模板内容，其中可以插入参数英文名，用${}包裹，比如${name}"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_sms_detail_modal, {
      value: _ctx.opeInfo.opeModalShowInfo.detailShow,
      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.opeInfo.opeModalShowInfo.detailShow) = $event)),
      "record-data": _ctx.opeInfo.recordData
    }, null, 8, ["value", "record-data"])
  ]))
}